<pre>
  This example is cleaner NGRX sample
</pre>

<div *ngIf="(movies && movies.length > 0) else show_loading"
  class="movies">

<section *ngFor="let movie of movies$ | async;let i = index">

 <mat-card style="position: relative;">

   <div style="position: absolute; right: 20px">
     <button mat-icon-button>
       <mat-icon (click)="enableEdit(movie, i)">edit</mat-icon>
     </button>
   </div>

   <h1> {{movie.Name}} </h1>

   <h2> {{ movie.ReleaseDate | date }} </h2>

   <ng-template #ear>
     <h3> ${{ movie.Earning }} million </h3>
   </ng-template>

   <mat-form-field *ngIf="i === selectedIndex; else ear"
                   class="example-full-width"
                   appearance="fill">

     <mat-label>Earning</mat-label>

     <input matInput
            type="number"
            placeholder="Ex. Pizza"
            [(ngModel)]="earning">

   </mat-form-field>

   <mat-card-actions>

     <button mat-button
             (click)="deleteMovie(movie.Id)">Delete</button>

     <button mat-button
             *ngIf="i === selectedIndex"
             (click)="update(movie)">Update</button>

     <button mat-button
             *ngIf="i === selectedIndex"
             (click)="cancelEdit()">Cancel</button>

     <!-- <button mat-button
             routerLink='/ngrx-testing/{{movie.Id}}'>Details</button> -->

   </mat-card-actions>

 </mat-card>

</section>

</div>

<ng-template #show_loading>
<mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>

